import gql from "graphql-tag";
const getOwnerSamplesQuery = gql(` 
query getOwnerSamples($owner: String!) {
  queryGenoplotsamplesByOwnerIndex(owner: $owner) {
      items{group customgroup sample alias origin v2 outlier geo SSE ethnicity age description coords coords2 simulated vendor object bucket type public download entityType}
  } 
}   
`)
export default getOwnerSamplesQuery;
